// extracted by mini-css-extract-plugin
module.exports = {"DuplicateData":"_1EOAivLV_TBFELqiT5GKpA"};